export type CheckoutPlanType = 'free' | 'monthly' | 'annual';

export interface CheckoutPlanContent {
  displayName: string;
  headline: string;
  subhead: string;
  features: string[];
  hasTrial: boolean;
  trialDays: number;
  trialDetail: string;
  paymentSubtitle: string;
  ctaLabel: string;
}

export const CHECKOUT_PLAN_CONTENT: Record<CheckoutPlanType, CheckoutPlanContent> = {
  free: {
    displayName: 'Waterlily Monthly',
    headline: '14 days free',
    subhead: 'Then Billed monthly',
    features: [
      'Full access to all features',
      'Up to 100 client LTC plans',
      'Live customer support',
    ],
    hasTrial: true,
    trialDays: 14,
    trialDetail:
      "Cancel anytime. You won't be billed until {{trialEndDate}}. Don't worry — we'll email you 2-3 days before your trial ends so you can cancel if it's not a fit.",
    paymentSubtitle: "Your card won't be charged until your trial ends.",
    ctaLabel: 'Start trial',
  },
  monthly: {
    displayName: 'Waterlily Monthly',
    headline: 'Billed monthly',
    subhead: 'No long-term commitment. Cancel anytime.',
    features: [
      'Full access to all features',
      'Up to 100 client LTC plans',
      'Live customer support',
    ],
    hasTrial: false,
    trialDays: 0,
    trialDetail: '',
    paymentSubtitle: 'Your card will be charged immediately.',
    ctaLabel: 'Subscribe now',
  },
  annual: {
    displayName: 'Waterlily Annual',
    headline: 'Billed annually',
    subhead: '$564.00 total per year. Best value.',
    features: [
      'Full access to all features',
      'Up to 100 client LTC plans',
      'Live customer support',
    ],
    hasTrial: false,
    trialDays: 0,
    trialDetail: '',
    paymentSubtitle: 'Your card will be charged immediately.',
    ctaLabel: 'Subscribe now',
  },
};
